var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6458 17.1516C20.823 14.328 20.3982 12.9112 20.3982 8.39998C20.3982 3.76077 16.6382 0 11.9998 0C7.36141 0 3.60143 3.76082 3.60143 8.39998C3.60143 10.8324 3.53665 11.7404 3.20182 12.8552C2.78543 14.244 1.93062 15.5736 0.353425 17.1516C-0.402151 17.9076 0.133066 19.2 1.20186 19.2H7.86063L7.80021 19.8C7.80021 22.1196 9.68022 24 11.9994 24C14.3186 24 16.1986 22.1196 16.1986 19.8L16.1382 19.2H22.7974C23.8666 19.2 24.4018 17.9076 23.6458 17.1516ZM12.0002 22.8C10.3438 22.8 9.00062 21.4564 9.00062 19.8L9.06105 19.2H14.9386L14.9999 19.8C14.9998 21.4564 13.6566 22.8 12.0002 22.8ZM1.20224 18C4.80143 14.4 4.80143 12 4.80143 8.39998C4.80143 4.42401 8.02422 1.2 11.9998 1.2C15.9754 1.2 19.1982 4.42401 19.1986 8.39998C19.1986 12 19.1986 14.4 22.7978 18H1.20224Z",
    fill: "black",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(-0.000244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.da48528260372fde2d34f5d1f2799adb.svg";
export { ForwardRef as ReactComponent };